module.exports = __webpack_public_path__ + "static/media/steyncity-logo.47f77fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steyncity-logo.png
// module id = 711
// module chunks = 21